type ChipProps = {
    label: string;
    onRemove?: () => void;
    onClick?: () => void;
};

function Chip({ label, onRemove, onClick }: ChipProps) {
    return (
        <div className="fireknife-chip fireknife-chip__color1" onClick={onClick}>
            <span className="fireknife-chip__label">{label}</span>
            {onRemove && (
                <a className="fireknife-chip__remove" onClick={onRemove}>
                    &times;
                </a>
            )}
        </div>
    );
}

export default Chip;
export type { ChipProps };
